import {Pipe, PipeTransform} from '@angular/core';

import {INTEGRATION_TASKS_EDUTONE_TITLE_MAP} from '@app/views/admin/application-settings/models/integration.model';
import {FilterRuleMetadata} from '@app/core/model/filtering/filter-rule-metadata';
import {DataSourceType} from '@app/views/admin/application-settings/models/data-source-type.model';

@Pipe({
    name: 'ngcGetAvailableLinkedEntityList'
})
export class GetAvailableLinkedEntityListPipe implements PipeTransform {

    public readonly NOT_LINKED_ENTITIES = ['School', 'SchoolAdmin', 'Category'];
    public readonly ENROLLMENT = 'RosterStudentEnrollment';
    public readonly CATEGORY = 'Category';

    transform(filterRulesMetadata: FilterRuleMetadata[], entityType: string, integrationDataSourceType: DataSourceType = null): any {
        const extension: FilterRuleMetadata[] = [];
        if ((integrationDataSourceType === DataSourceType.GSuite) || (integrationDataSourceType === DataSourceType.LDAP)) {
            if (!filterRulesMetadata.some((metadata: FilterRuleMetadata) => metadata.type === this.ENROLLMENT)) {
                extension.push(new FilterRuleMetadata([], this.ENROLLMENT));
            }
        }

        return filterRulesMetadata.concat(extension)
            .map((metadata: FilterRuleMetadata) => metadata.type)
            .filter((type: string) =>
                (type !== entityType)
                && (entityType !== this.CATEGORY) // No linked entities for category
                && !this.NOT_LINKED_ENTITIES.includes(type) // Don't allow to set NOT_LINKED_ENTITIES as linked entity
            ).sort((a, b) => {
                const entityA = INTEGRATION_TASKS_EDUTONE_TITLE_MAP[a] ? INTEGRATION_TASKS_EDUTONE_TITLE_MAP[a] : a;
                const entityB = INTEGRATION_TASKS_EDUTONE_TITLE_MAP[b] ? INTEGRATION_TASKS_EDUTONE_TITLE_MAP[b] : b;
                return entityA.localeCompare(entityB);
            });
    }
}
